export default __webpack_public_path__ + "static/media/checkcc.552a2b10.svg";